import React from "react";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const RequestDelayBadge: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Badge
      variant="destructive"
      className={cn("gap-1 rounded-full px-2 py-0.5", className)}
    >
      <AlertTriangle className="size-3" />
      {t("requests.delay.overdue")}
    </Badge>
  );
};
